'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMaxWidgetHeight = calculateMaxWidgetHeight;

var _dimensions = require('../constants/dimensions');

function calculateMaxWidgetHeight(_ref) {
  var showCloseButton = _ref.showCloseButton;

  var maxHeight = _dimensions.BASE_WIDGET_HEIGHT + _dimensions.SPACING_ABOVE_WIDGET;
  if (showCloseButton) {
    maxHeight += _dimensions.CLOSE_BUTTON_AND_SPACING;
  }

  return maxHeight;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/widget-dimensions/util/calculateMaxWidgetHeight.js
// module id = 1044
// module chunks = 2 3